import React, { useEffect, useState, Fragment, useRef } from "react";
import { Checkbox } from "@material-ui/core";
import { LoadingMaterialTable } from "../../../Common/table";
import ReactToPrint from "react-to-print";
import CreatePdf from "./createpdf";
import services from "../services";
import tokenService from "../../../Common/tokenDecoder";
import MessageModal from "../../../UI/Modal/MessageModal";

var QRCode = require("qrcode.react");

export const BagQRPrintListing = (props) => {
  const componentRef = useRef();
  const { bagQRTags, afterSuccessfulyChanged } = props;
  const [qrTags, setQRTags] = useState([]);
  const [saveData, setSaveData] = useState([]);
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "",
    disciption: "",
  });

  useEffect(() => {
    setQRTags(bagQRTags);
    setSaveData([]);
  }, [bagQRTags]);

  function getTagKey(data) {
    return String(data.collectionTagID || data.CollectionTagID || data.tagNo);
  }

  function handleClick(data) {
    const tagKey = getTagKey(data);
    const isSelected = saveData.some((x) => getTagKey(x) === tagKey);

    setSaveData(
      isSelected
        ? saveData.filter((x) => getTagKey(x) !== tagKey)
        : saveData.concat([
          {
            collectionTagID: data.collectionTagID || data.CollectionTagID,
            tagNo: data.tagNo,
          },
        ])
    );
  }

  function handleClickAll(e) {
    if (e.target.checked) {
      setSaveData(
        qrTags.map((x) => ({
          collectionTagID: x.collectionTagID || x.CollectionTagID,
          tagNo: x.tagNo,
        }))
      );
    } else {
      setSaveData([]);
    }
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  async function handleAfterPrint() {
    const idsToMark = saveData
      .map((x) => x.collectionTagID)
      .filter((id) => id !== undefined && id !== null);

    if (idsToMark.length === 0) return;

    const token = tokenService.getUserDetailsFromTokenV2();
    const modifiedBy = token.id || 0;

    const response = await services.markBagQRTagsAsPrinted(idsToMark, modifiedBy);

    if (response && response.statusCode === "Success") {
      setMessageModel({
        hidden: false,
        type: "Success",
        disciption: "QR tags are printed successfully.",
      });
      setTimeout(() => {
        setMessageModel({ ...messageModel, hidden: true });
      }, 3000);
    } else {
      setMessageModel({
        hidden: false,
        type: "Error",
        disciption: "Something went wrong while marking QR tags as printed.",
      });
    }

    if (afterSuccessfulyChanged) {
      afterSuccessfulyChanged();
    }
  }

  return (
    <Fragment>
      <LoadingMaterialTable
        title=""
        columns={[
          {
            title: (
              <label>
                <Checkbox
                  color="primary"
                  onChange={(e) => handleClickAll(e)}
                  checked={
                    qrTags.length > 0 &&
                    qrTags.every((x) =>
                      saveData.some((y) => getTagKey(y) === getTagKey(x))
                    )
                  }
                ></Checkbox>
                Select All
              </label>
            ),
            sorting: false,
            field: "select",
            type: "boolean",
            render: (data) => (
              <Checkbox
                color="primary"
                onChange={() => handleClick(data)}
                checked={saveData.some(
                  (x) => getTagKey(x) === getTagKey(data)
                )}
              ></Checkbox>
            ),
          },
          { title: "Tag Number", field: "tagNo" },
          {
            title: "QR Code",
            field: "qrCode",
            render: (rawData) => <QRCode value={rawData.tagNo} size={56} />,
          },
        ]}
        data={qrTags}
      />

      <div className="card-footer">
        <ReactToPrint
          trigger={() => (
            <input
              type="button"
              className="btn btn-primary pull-right ml-2"
              value="Create PDF"
              disabled={saveData.length === 0}
            />
          )}
          content={() => componentRef.current}
          onAfterPrint={handleAfterPrint}
          documentTitle="BPL QR Tags"
        />
      </div>

      <div hidden={true}>
        <CreatePdf data={saveData} ref={componentRef} />
      </div>

      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
};